import createProjectForm from 'root/src/shared/descriptions/formSubmits/createProjectForm'
import pledgeProjectForm from 'root/src/shared/descriptions/formSubmits/pledgeProjectForm'
import loginForm from 'root/src/shared/descriptions/formSubmits/loginForm'
import signUpForm from 'root/src/shared/descriptions/formSubmits/signUpForm'
import signUpTokenForm from 'root/src/shared/descriptions/formSubmits/signUpTokenForm'
import forgotPassword from 'root/src/shared/descriptions/formSubmits/forgotPassword'
import resetPassword from 'root/src/shared/descriptions/formSubmits/resetPassword'
import changePasswordForm from 'root/src/shared/descriptions/formSubmits/changePasswordForm'
import addBrandProductForm from 'root/src/shared/descriptions/formSubmits/addBrandProductForm'
import brandSettingsForm from 'root/src/shared/descriptions/formSubmits/setBrandSettingsForm'
import claimProjectForm from 'root/src/shared/descriptions/formSubmits/claimProjectForm'
import deliveryDareForm from 'root/src/shared/descriptions/formSubmits/deliveryDareForm'
import addPayoutForm from 'root/src/shared/descriptions/formSubmits/addPayoutForm'
import addCouponForm from 'root/src/shared/descriptions/formSubmits/addCouponForm'
import filterDaresForm from 'root/src/shared/descriptions/formSubmits/filterDaresForm'
import featuredDaresAdminForm from 'root/src/shared/descriptions/formSubmits/featuredDaresAdminForm'
import dropUploadKeysForm from 'root/src/shared/descriptions/formSubmits/dropUploadKeysForm'
import dropAdminListSearchForm from 'root/src/shared/descriptions/formSubmits/dropAdminListSearchForm'
import setEmailForm from 'root/src/shared/descriptions/formSubmits/setEmailForm'
import dropUploadCodesForm from 'root/src/shared/descriptions/formSubmits/dropUploadCodesForm'
import shortUrlReportDownload from 'root/src/shared/descriptions/formSubmits/shortUrlReportDownload'
import adminBanForm from 'root/src/shared/descriptions/formSubmits/adminBanForm'
import requestInvoiceForm from 'root/src/shared/descriptions/formSubmits/requestInvoiceForm'
import addAgencyPublisherForm from 'root/src/shared/descriptions/formSubmits/addAgencyPublisherForm'
import submitEmailForm from 'root/src/shared/descriptions/formSubmits/submitEmailForm'
import setPublisherNotificationSettingsForm from 'root/src/shared/descriptions/formSubmits/setPublisherNotificationSettingsForm'
import addAgencyAccountManagerForm
	from 'root/src/shared/descriptions/formSubmits/addAgencyAccountManagerForm'
import transferAccountForm from 'root/src/shared/descriptions/formSubmits/transferAccountForm'
import { rewardsBulkUploadForm } from 'root/src/shared/descriptions/formSubmits/rewardsBulkUploadForm'

export default {
	...createProjectForm,
	...pledgeProjectForm,
	...loginForm,
	...signUpForm,
	...forgotPassword,
	...resetPassword,
	...changePasswordForm,
	...addBrandProductForm,
	...brandSettingsForm,
	...claimProjectForm,
	...deliveryDareForm,
	...addPayoutForm,
	...addCouponForm,
	...filterDaresForm,
	...featuredDaresAdminForm,
	...dropUploadKeysForm,
	...dropAdminListSearchForm,
	...setEmailForm,
	...dropUploadCodesForm,
	...shortUrlReportDownload,
	...adminBanForm,
	...requestInvoiceForm,
	...addAgencyPublisherForm,
	...signUpTokenForm,
	...submitEmailForm,
	...setPublisherNotificationSettingsForm,
	...addAgencyAccountManagerForm,
	...transferAccountForm,
	...rewardsBulkUploadForm,
}
